import React, { useEffect } from "react";
import { AzureADB2CSignInRedirect } from "../../../../../utils/Authentication/Azure/MSALInstanceInit";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import WebHome from "../../../../Home/WebHome";

const SignUpRedirect = (props) => {
    const { inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const signUpType = props?.location?.state?.signupType;

    useEffect(() => {
        if(inProgress === InteractionStatus.None && !isAuthenticated ){
            AzureADB2CSignInRedirect(signUpType);
         }
    }, [signUpType, inProgress, isAuthenticated])

    return(
        <WebHome />
    )
}

export default SignUpRedirect;
